import * as React from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import SvgEnterprise from '@splunk/react-icons/SVGEnterprise';

const RichText = (props: React.ComponentProps<typeof SvgEnterprise>): React.ReactElement<SVGElement> => (
    <SvgEnterprise screenReaderText={_('Rich Text')} fill="currentColor" viewBox="0 0 28 20" {...props}>
        {/* Outer border as evenodd ring */}
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.9165 3.33334C6.22615 3.33334 5.6665 3.89299 5.6665 4.58334V15.4167C5.6665 16.107 6.22615 16.6667 6.9165 16.6667H21.0832C21.7735 16.6667 22.3332 16.107 22.3332 15.4167V4.58334C22.3332 3.89299 21.7735 3.33334 21.0832 3.33334H6.9165ZM7.33317 15V5.00001H20.6665V15H7.33317Z"
        />
        {/* T letter */}
        <path d="M11.4998 9.16668C11.9601 9.16668 12.3332 8.79358 12.3332 8.33334H13.1665V11.6667H12.7498C12.2896 11.6667 11.9165 12.0398 11.9165 12.5C11.9165 12.9602 12.2896 13.3333 12.7498 13.3333H15.2498C15.7101 13.3333 16.0832 12.9602 16.0832 12.5C16.0832 12.0398 15.7101 11.6667 15.2498 11.6667H14.8332V8.33334H15.6665C15.6665 8.79358 16.0396 9.16668 16.4998 9.16668C16.9601 9.16668 17.3332 8.79358 17.3332 8.33334V7.70834C17.3332 7.13305 16.8668 6.66668 16.2915 6.66668H11.7082C11.1329 6.66668 10.6665 7.13305 10.6665 7.70834V8.33334C10.6665 8.79358 11.0396 9.16668 11.4998 9.16668Z" />
    </SvgEnterprise>
);

export default RichText;
